import { IconButton } from "@mui/material";
import { shade } from "polished";
import { MdClose } from "react-icons/md";
import styled from "styled-components";

const CustomIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    z-index: 10;
    border-radius: 50%;
    background-color: #14141496;

    &:hover {
      background-color: ${shade(0.25, "#14141496")};
    }
  }
`;

const FullscreenCloseButton = ({
  handleClick,
}: {
  handleClick: () => void;
}) => {
  return (
    <CustomIconButton onClick={handleClick}>
      <MdClose size={22} fill="white" />
    </CustomIconButton>
  );
};

export default FullscreenCloseButton;
